import { useEffect, useState } from 'react';
import routes_web from '../../connections/routes_web';
import { useAuth } from '../../connections/AuthContext';
import { useNavigate } from 'react-router-dom';

const Initial = () => {
  const { user, get_user } = useAuth();
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState({
    isLoading: true,
    hasChecked: false
  });

  // ##### MELHORIA 2: Verificar dados completos
  const hasCompleteUserData = () => {
    if (!user) return false;
    
    // Verifica se tem app_preferences (dados completos)
    const hasPreferences = Array.isArray(user.app_preferences) && 
                           user.app_preferences.length > 0;
    
    // Verifica se tem app_initial configurado
    const hasInitialApp = user.app_initial && typeof user.app_initial === 'string';
    
    return hasPreferences && hasInitialApp;
  };

  // ##### MELHORIA 1 + 2 + 3: Lógica principal
  useEffect(() => {
    const checkAndRedirect = async () => {
      try {
        // ##### OPTIMIZATION: If user already exists (from cache), skip loading state
        if (user) {
          setLoadingState({ isLoading: false, hasChecked: true });
        } else {
          // MELHORIA 3: Estado de loading explícito
          setLoadingState({ isLoading: true, hasChecked: false });
          
          // MELHORIA 1: Garantir carregamento do user
          await get_user();
          return; // Aguarda re-render com user carregado
        }
        
        setLoadingState({ isLoading: false, hasChecked: true });
        
        // MELHORIA 2: Verificar dados completos (offline-first)
        const isOffline = !navigator.onLine;
        if (isOffline && !hasCompleteUserData()) {
          console.warn('Incomplete user data offline - using safe fallback');
          navigate(routes_web.accounts_main);
          return;
        }
        
        // Lógica de redirecionamento original
        const prefs = user.app_preferences || [];
        
        if (user.app_initial && prefs.some(p => 
          p.app_key === user.app_initial && 
          p.app_enabled && 
          p.app_visible
        )) {
          const route = routes_web[`${user.app_initial}_main`];
          if (route) {
            navigate(route);
            return;
          }
        }
        
        // Fallback padrão
        navigate(routes_web.accounts_main);
        
      } catch (error) {
        console.error('Error in Initial component:', error);
        setLoadingState({ isLoading: false, hasChecked: true });
        navigate(routes_web.accounts_main);
      }
    };
    
    checkAndRedirect();
  }, [user, get_user, navigate]);

  // ##### MELHORIA 3: Render com feedback baseado no estado
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="flex flex-col items-center gap-4">
        <div className="border-4 border-gray-300 border-t-gray-700 rounded-full w-8 h-8 animate-spin"></div>
        {loadingState.hasChecked && !user && (
          <p className="text-sm text-gray-500">Loading user data...</p>
        )}
      </div>
    </div>
  );
};

export default Initial;
